import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const FeatureCard = ({ to, title, description, icon, cta = 'عرض المزيد' }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.45 }}
  >
    <Link
      to={to}
      className="group flex h-full flex-col rounded-3xl border border-stone-200/80 bg-white/80 p-6 shadow-soft backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-gold-400/50 hover:shadow-large dark:border-stone-800 dark:bg-stone-900/80"
    >
      <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-50 text-3xl dark:bg-primary-900/40">
        {icon}
      </div>
      <h3 className="mb-2 text-xl font-bold text-primary-900 dark:text-primary-100">{title}</h3>
      <p className="mb-6 flex-1 text-stone-600 dark:text-stone-400 leading-relaxed">{description}</p>
      <span className="text-sm font-semibold text-gold-700 transition-colors group-hover:text-gold-600 dark:text-gold-400">
        {cta} ←
      </span>
    </Link>
  </motion.div>
);

export default FeatureCard;
